export { useFocusRing } from '@react-aria/focus';
//# sourceMappingURL=useFocusRing.web.js.map